"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleCategoryPrefix = getLocaleCategoryPrefix;
exports.getLocaleTagPrefix = getLocaleTagPrefix;
exports.getLocaleGamePrefix = getLocaleGamePrefix;
exports.getLocaleDomainDetails = getLocaleDomainDetails;
exports.getLocaleDomain = getLocaleDomain;
exports.getLocaleLanguage = getLocaleLanguage;
exports.isMigratedToMainDomain = isMigratedToMainDomain;
const isDefined_1 = require("@crazygames/utils/isDefined");
const localeToCategoryPrefix = {
    nl_NL: { new: 'categorie', old: 'categorie' },
    it_IT: { new: 'c', old: 'categoria' },
    es_ES: { new: 'c', old: 'categoria' },
    th_TH: { new: 'c', old: 'หมวดหมู่' },
    id_ID: { new: 'k', old: 'k' },
    el_GR: { new: 'c', old: 'k' },
    tr_TR: { new: 'c', old: 'k' },
    en_US: { new: 'c', old: 'c' },
    fr_FR: { new: 'c', old: 'c' },
    pt_BR: { new: 'c', old: 'c' },
    ru_RU: { new: 'c', old: 'c' },
    pl_PL: { new: 'c', old: 'c' },
    ro_RO: { new: 'c', old: 'c' },
    de_DE: { new: 'c', old: 'c' },
    nb_NO: { new: 'c', old: 'c' },
    sv_SE: { new: 'c', old: 'c' },
    fi_FI: { new: 'c', old: 'c' },
    uk_UA: { new: 'c', old: 'c' },
    da_DK: { new: 'c', old: 'c' },
    cs_CZ: { new: 'c', old: 'c' },
    hu_HU: { new: 'c', old: 'c' },
    ar_SA: { new: 'c', old: 'c' },
    vi_VN: { new: 'c', old: 'c' },
    ko_KR: { new: 'c', old: 'c' },
    ja_JP: { new: 'c', old: 'c' },
};
const localeToTagPrefix = {
    nl_NL: { new: 'tag', old: 'tag' },
    it_IT: { new: 't', old: 'tipo' },
    es_ES: { new: 't', old: 'e' },
    el_GR: { new: 't', old: 'e' },
    tr_TR: { new: 't', old: 'e' },
    th_TH: { new: 't', old: 'แท็ก' },
    en_US: { new: 't', old: 't' },
    id_ID: { new: 't', old: 't' },
    fr_FR: { new: 't', old: 't' },
    pt_BR: { new: 't', old: 't' },
    ru_RU: { new: 't', old: 't' },
    pl_PL: { new: 't', old: 't' },
    ro_RO: { new: 't', old: 't' },
    de_DE: { new: 't', old: 't' },
    nb_NO: { new: 't', old: 't' },
    sv_SE: { new: 't', old: 't' },
    fi_FI: { new: 't', old: 't' },
    uk_UA: { new: 't', old: 't' },
    da_DK: { new: 't', old: 't' },
    cs_CZ: { new: 't', old: 't' },
    hu_HU: { new: 't', old: 't' },
    ar_SA: { new: 't', old: 't' },
    vi_VN: { new: 't', old: 't' },
    ko_KR: { new: 't', old: 't' },
    ja_JP: { new: 't', old: 't' },
};
const localeToGamePrefix = {
    nl_NL: { new: 'spel', old: 'spel' },
    it_IT: { new: 'game', old: 'gioco' },
    es_ES: { new: 'game', old: 'juego' },
    fr_FR: { new: 'jeu', old: 'jeu' },
    pt_BR: { new: 'jogos', old: 'jogos' },
    ru_RU: { new: 'igra', old: 'igra' },
    de_DE: { new: 'game', old: 'spiele' },
    fi_FI: { new: 'peli', old: 'peli' },
    nb_NO: { new: 'spill', old: 'spill' },
    pl_PL: { new: 'gra', old: 'gra' },
    ro_RO: { new: 'joc', old: 'joc' },
    sv_SE: { new: 'spel', old: 'spel' },
    uk_UA: { new: 'gra', old: 'gra' },
    el_GR: { new: 'game', old: 'paixnidi' },
    da_DK: { new: 'game', old: 'spil' },
    cs_CZ: { new: 'hra', old: 'hra' },
    hu_HU: { new: 'jatek', old: 'jatek' },
    tr_TR: { new: 'game', old: 'oyun' },
    vi_VN: { new: 'game', old: 'trò-chơi' },
    th_TH: { new: 'game', old: 'เกม' },
    ko_KR: { new: '게임', old: '게임' },
    en_US: { new: 'game', old: 'game' },
    id_ID: { new: 'game', old: 'game' },
    ar_SA: { new: 'game', old: 'game' },
    ja_JP: { new: 'game', old: 'game' },
};
const localeToProdDomainDetails = {
    en_US: {
        base: `https://www.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    nl_NL: {
        base: `https://www.crazygames.nl`,
        pathname: '',
        domain: 'crazygames.nl',
    },
    it_IT: {
        base: `https://www.crazygames.com`,
        pathname: '/it',
        domain: 'crazygames.com',
        migrated: true,
    },
    es_ES: {
        base: `https://www.crazygames.com`,
        pathname: '/es',
        domain: 'crazygames.com',
        migrated: true,
    },
    id_ID: {
        base: `https://www.crazygames.co.id`,
        pathname: '',
        domain: 'crazygames.co.id',
    },
    fr_FR: {
        base: `https://www.crazygames.fr`,
        pathname: '',
        domain: 'crazygames.fr',
    },
    pt_BR: {
        base: `https://www.crazygames.com.br`,
        pathname: '',
        domain: 'crazygames.com.br',
    },
    ru_RU: {
        base: `https://www.crazygames.ru`,
        pathname: '',
        domain: 'crazygames.ru',
    },
    de_DE: {
        base: `https://www.crazygames.com`,
        pathname: '/de',
        domain: 'crazygames.com',
        migrated: true,
    },
    pl_PL: {
        base: `https://www.crazygames.pl`,
        pathname: '',
        domain: 'crazygames.pl',
    },
    ro_RO: {
        base: `https://www.crazygames.ro`,
        pathname: '',
        domain: 'crazygames.ro',
    },
    nb_NO: {
        base: `https://www.crazygames.no`,
        pathname: '',
        domain: 'crazygames.no',
    },
    sv_SE: {
        base: `https://www.crazygames.se`,
        pathname: '',
        domain: 'crazygames.se',
    },
    fi_FI: {
        base: `https://www.crazygames.fi`,
        pathname: '',
        domain: 'crazygames.fi',
    },
    uk_UA: {
        base: `https://www.crazygames.com.ua`,
        pathname: '',
        domain: 'crazygames.com.ua',
    },
    el_GR: {
        base: `https://www.crazygames.com`,
        pathname: '/gr',
        domain: 'crazygames.com',
        migrated: true,
    },
    da_DK: {
        base: `https://www.crazygames.com`,
        pathname: '/dk',
        domain: 'crazygames.com',
        migrated: true,
    },
    cs_CZ: {
        base: `https://www.crazygames.cz`,
        pathname: '',
        domain: 'crazygames.cz',
    },
    hu_HU: {
        base: `https://www.crazygames.hu`,
        pathname: '',
        domain: 'crazygames.hu',
    },
    tr_TR: {
        base: `https://www.crazygames.com`,
        pathname: '/tr',
        domain: 'crazygames.com',
        migrated: true,
    },
    ar_SA: {
        base: `https://www.crazygames.com`,
        pathname: '/ar',
        domain: 'crazygames.com',
        migrated: true,
    },
    vi_VN: {
        base: `https://www.crazygames.com`,
        pathname: '/vn',
        domain: 'crazygames.com',
        migrated: true,
    },
    th_TH: {
        base: `https://www.crazygames.com`,
        pathname: '/th',
        domain: 'crazygames.com',
        migrated: true,
    },
    ko_KR: {
        base: `https://www.crazygames.co.kr`,
        pathname: '',
        domain: 'crazygames.co.kr',
    },
    ja_JP: {
        base: `https://www.crazygames.com`,
        pathname: '/jp',
        domain: 'crazygames.com',
    },
};
const localeToDevDomainDetails = {
    en_US: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    nl_NL: {
        base: `https://nl-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    it_IT: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/it',
        domain: 'dev-crazygames.be',
    },
    es_ES: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/es',
        domain: 'dev-crazygames.be',
    },
    id_ID: {
        base: `https://id-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    fr_FR: {
        base: `https://fr-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    pt_BR: {
        base: `https://br-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    ru_RU: {
        base: `https://ru-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    de_DE: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/de',
        domain: 'dev-crazygames.be',
    },
    pl_PL: {
        base: `https://pl-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    ro_RO: {
        base: `https://ro-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    nb_NO: {
        base: `https://no-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    sv_SE: {
        base: `https://se-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    fi_FI: {
        base: `https://fi-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    uk_UA: {
        base: `https://uk-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    el_GR: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/gr',
        domain: 'dev-crazygames.be',
    },
    da_DK: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/dk',
        domain: 'dev-crazygames.be',
    },
    cs_CZ: {
        base: `https://cz-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    hu_HU: {
        base: `https://hu-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    tr_TR: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/tr',
        domain: 'dev-crazygames.be',
    },
    ar_SA: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/ar',
        domain: 'dev-crazygames.be',
    },
    vi_VN: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/vn',
        domain: 'dev-crazygames.be',
    },
    th_TH: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/th',
        domain: 'dev-crazygames.be',
    },
    ko_KR: {
        base: `https://kr-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    ja_JP: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/jp',
        domain: 'dev-crazygames.be',
    },
};
function getLocaleCategoryPrefix(locale) {
    const prefix = localeToCategoryPrefix[locale];
    if (!(0, isDefined_1.isDefined)(prefix)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return prefix;
}
function getLocaleTagPrefix(locale) {
    const prefix = localeToTagPrefix[locale];
    if (!(0, isDefined_1.isDefined)(prefix)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return prefix;
}
function getLocaleGamePrefix(locale) {
    const prefix = localeToGamePrefix[locale];
    if (!(0, isDefined_1.isDefined)(prefix)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return prefix;
}
function getLocaleDomainDetails(locale, environment) {
    const domainDetails = getLocaleDomainRecord(environment)[locale];
    if (!(0, isDefined_1.isDefined)(domainDetails)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return domainDetails;
}
function getLocaleDomainRecord(environment) {
    switch (environment) {
        case 'dev':
            return localeToDevDomainDetails;
        case 'prod':
            return localeToProdDomainDetails;
    }
}
function getLocaleDomain(locale) {
    const localeProdDomainDetails = getLocaleDomainDetails(locale, 'prod');
    return `${localeProdDomainDetails.base}${localeProdDomainDetails.pathname}`;
}
/**
 * Returns the ISO 639 language code for the given locale
 */
function getLocaleLanguage(locale) {
    // The language is the first part of the locale, and it is in the ISO 639 specification
    // Otherwise, it wouldn't be a valid locale
    return locale.split('_')[0];
}
/**
 * Localised domains (example : 1001juegos.com, tr.crazygames.com, crazygames.dk) have been migrated to crazygames.com/es (or /tr or /dk)
 *
 * This is a helper function which returns which domains have gone through a migration
 */
function isMigratedToMainDomain(locale) {
    return !!getLocaleDomainDetails(locale, 'prod').migrated;
}
